var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "question-row" }, [
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-12 col-lg-4 question-row__title" }, [
        _vm._v(" " + _vm._s(_vm.question.name) + " ")
      ]),
      _c(
        "div",
        { staticClass: "col-12 col-lg-8" },
        [
          _c("validation-provider", {
            ref: "answersProvider",
            attrs: {
              name: `question-${_vm.question.id}`,
              rules: "required_structured_answers",
              vid: `question-${_vm.question.id}`
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function({ errors }) {
                  return [
                    _c(
                      "div",
                      { staticClass: "row" },
                      [
                        _vm._l(_vm.mainAnswers, function(answer, index) {
                          return _c(
                            "div",
                            {
                              key: answer.id,
                              staticClass: "col-6 col-md-4 col-xl mb-2",
                              class: {
                                "answer-col--with-divider": index === 1
                              }
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "answer-card",
                                  class: {
                                    "answer-card--selected":
                                      _vm.model.selectedMainAnswerId ===
                                        answer.id && !_vm.isReadOnly,
                                    "answer-card--disabled-selected":
                                      _vm.model.selectedMainAnswerId ===
                                        answer.id && _vm.isReadOnly,
                                    "answer-card--readonly": _vm.isReadOnly
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.selectAnswer(answer)
                                    }
                                  }
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "answer-card__radio-circle",
                                      class: {
                                        "answer-card__radio-circle--selected":
                                          _vm.model.selectedMainAnswerId ===
                                            answer.id && !_vm.isReadOnly,
                                        "answer-card__radio-circle-disabled--selected":
                                          _vm.model.selectedMainAnswerId ===
                                            answer.id && _vm.isReadOnly
                                      }
                                    },
                                    [
                                      _vm.model.selectedMainAnswerId ===
                                      answer.id
                                        ? _c("i", {
                                            staticClass:
                                              "fas fa-check answer-card__check"
                                          })
                                        : _vm._e()
                                    ]
                                  ),
                                  _c("div", { staticClass: "vr" }),
                                  _c(
                                    "div",
                                    { staticClass: "answer-card__label" },
                                    [_vm._v(" " + _vm._s(answer.name) + " ")]
                                  )
                                ]
                              )
                            ]
                          )
                        }),
                        _vm._l(_vm.supportAnswers, function(answer, index) {
                          return _c(
                            "div",
                            {
                              key: answer.id,
                              staticClass: "col-6 col-md-4 col-xl mb-2",
                              class: {
                                "answer-col--with-divider": index === 2
                              }
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "answer-card",
                                  class: {
                                    "answer-card--selected":
                                      _vm.model.selectedSupportAnswerId ===
                                        answer.id && !_vm.isReadOnly,
                                    "answer-card--disabled-selected":
                                      _vm.model.selectedSupportAnswerId ===
                                        answer.id && _vm.isReadOnly,
                                    "answer-card--readonly": _vm.isReadOnly
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.selectAnswer(answer)
                                    }
                                  }
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "answer-card__radio-circle",
                                      class: {
                                        "answer-card__radio-circle--selected":
                                          _vm.model.selectedSupportAnswerId ===
                                            answer.id && !_vm.isReadOnly,
                                        "answer-card__radio-circle-disabled--selected":
                                          _vm.model.selectedSupportAnswerId ===
                                            answer.id && _vm.isReadOnly
                                      }
                                    },
                                    [
                                      _vm.model.selectedSupportAnswerId ===
                                      answer.id
                                        ? _c("i", {
                                            staticClass:
                                              "fas fa-check answer-card__check"
                                          })
                                        : _vm._e()
                                    ]
                                  ),
                                  _c("div", { staticClass: "vr" }),
                                  _c(
                                    "div",
                                    { staticClass: "answer-card__label" },
                                    [_vm._v(" " + _vm._s(answer.name) + " ")]
                                  )
                                ]
                              )
                            ]
                          )
                        })
                      ],
                      2
                    ),
                    _c("input", {
                      attrs: { type: "hidden" },
                      domProps: { value: _vm.questionValidationValue }
                    }),
                    errors[0]
                      ? _c(
                          "div",
                          { staticClass: "font-14 mt-1 error-message" },
                          [_vm._v(" " + _vm._s(errors[0]) + " ")]
                        )
                      : _vm._e()
                  ]
                }
              }
            ])
          }),
          _c("div", { staticClass: "question-row__observation-label" }, [
            _vm._v(" Observaciones: ")
          ]),
          _c("validation-provider", {
            attrs: {
              name: `observation-${_vm.question.id}`,
              rules: "required",
              vid: `observation-${_vm.question.id}`
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function({ errors }) {
                  return [
                    _c("textarea", {
                      staticClass: "form-control question-row__observation",
                      attrs: {
                        disabled: _vm.isReadOnly,
                        maxlength: "500",
                        rows: "2"
                      },
                      domProps: { value: _vm.model.observation },
                      on: {
                        input: function($event) {
                          return _vm.updateObservation($event.target.value)
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c("div", { staticClass: "error-message font-14 mt-1" }, [
                      _vm._v(" " + _vm._s(errors[0]) + " ")
                    ])
                  ]
                }
              }
            ])
          })
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }